import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Heart, Quote } from "lucide-react";
import api from "@/lib/api";
import PublicLayout from "@/components/layout/PublicLayout";

export default function Sobre() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    document.title = "Sobre — Ana Paula Moraes";
    api.get("/settings").then((r) => setSettings(r.data));
  }, []);

  const photo = settings?.photo_url || "https://customer-assets.emergentagent.com/job_06c22da0-53e2-45fc-a666-faa4c956a6c6/artifacts/azlm5cig_IMG_6115.JPG.jpeg";

  return (
    <PublicLayout>
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:sticky lg:top-28 lg:col-span-5 fade-in-up">
            <div className="hero-photo-frame max-w-md">
              <img src={photo} alt="Ana Paula Moraes" className="w-full object-cover" />
            </div>
            <div className="mt-8 flex items-center gap-3">
              <span className="serial-mark">N° 02</span>
              <div className="flex-1 h-px bg-[color:var(--copper)] opacity-30" />
              <span className="serial-mark uppercase tracking-[0.28em] text-[11px]">A história</span>
            </div>
            <div className="mt-6 font-display italic text-2xl leading-snug" style={{ color: "var(--copper)" }}>
              "Eu sou a CEO da minha vida."
            </div>
          </div>

          <div className="lg:col-span-7 fade-in-up delay-100">
            <div className="divider-ornament eyebrow mb-6">Sobre Ana Paula Moraes</div>
            <h1 className="headline-hero text-balance mb-8">
              Liderar a própria vida é, antes de tudo,{" "}
              <span className="headline-italic-accent">uma escolha diária</span>.
            </h1>
            <p className="body-lead mb-6 text-pretty">
              {settings?.about_text || "Ana Paula Moraes conduz mulheres em uma jornada de transformação pessoal, ajudando cada uma a reconhecer sua força, organizar sua vida com mais consciência e desenvolver uma mentalidade de liderança sobre suas próprias escolhas."}
            </p>

            <div className="grid sm:grid-cols-3 gap-5 my-12">
              {[
                { label: "Missão", value: settings?.mission, n: "I" },
                { label: "Visão", value: settings?.vision, n: "II" },
                { label: "Valores", value: settings?.values, n: "III" },
              ].map((b) => (
                <div key={b.label} className="brand-card p-7">
                  <div className="flex items-center justify-between mb-4">
                    <span className="eyebrow">{b.label}</span>
                    <span className="font-display italic text-xl" style={{ color: "var(--copper)" }}>{b.n}</span>
                  </div>
                  <p className="text-sm leading-relaxed" style={{ color: "var(--text-primary)" }}>{b.value || "—"}</p>
                </div>
              ))}
            </div>

            <div className="brand-card-flat p-10 my-12 relative overflow-hidden" style={{ background: "linear-gradient(135deg, rgba(196,143,149,0.08), rgba(184,115,51,0.05))", border: "1px solid rgba(196,143,149,0.18)" }}>
              <Quote size={28} style={{ color: "var(--rose-gold)" }} className="mb-4 opacity-60" />
              <p className="font-serif italic text-2xl md:text-3xl leading-snug" style={{ color: "var(--text-primary)" }}>
                Você não precisa esperar a vida mudar.{" "}
                <span style={{ color: "var(--copper)" }}>Você pode assumir o comando.</span>
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/contato" className="btn-primary" data-testid="sobre-cta-contato">
                Falar comigo <ArrowRight size={16} />
              </Link>
              <Link to="/login" className="btn-secondary" data-testid="sobre-cta-membros">
                Acessar área de membros
              </Link>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
